module.exports = __webpack_public_path__ + "img/scanner.a6db4755.svg";